import React from 'react'
import PropTypes from 'prop-types'
import { localsMessages, isOldButtonFactory } from '../utility/getTemplateData'
import { isLTR as isLeftToRight, getPPCCStatus } from '../utility/helper';
import { Text } from '@paypalcorp/pp-react'
import PPCC from './ppcc';

const MERCHANT_PPCC_CONFIRMED_STATUS = 'Confirmed';
const isLTR = isLeftToRight();
const messages = localsMessages('common/subHeader');

class SubHeader extends React.Component {
	constructor() {
		super();
		const { label: { donateto = '', purpose: purposeLabel = '' } = {} } = messages || {};
		this.state = { donateto, purposeLabel, };
	}

	formatOrgName() {
		let { label, orgName } = this.props;
		label = label && label.toString().replace(/\s/g, '').toUpperCase();
		let OName = orgName && orgName.toString().replace(/\s/g, '').toUpperCase();
		return label.includes(OName) ? '' : orgName;
	}

	shouldShowDonationId() {
		if (this.props.page === 'member' || this.props.page === 'crossborder') {
			return true;
		}
		return isOldButtonFactory();
	}

	render() {
		let { donateto = '', purposeLabel = '' } = this.state;
		let donationName = this.props.label;
		let orgName = this.formatOrgName();
		let donationId = this.props.donationId;
		let { formattedDonationName, formattedOrgName, formattedDonationId } = {};

		if (donationName === orgName) {
			formattedDonationName = donationName;
			formattedOrgName = '';
		} else {
			formattedDonationName = donationName
		}

		if (orgName && !donationId) {
			if (donationName !== orgName) {
				formattedOrgName = isLTR ? `${purposeLabel} ${orgName}` : `${orgName} ${purposeLabel}`;
			}
		}

		if (!orgName && donationId) {
			formattedDonationId = isLTR ? `${purposeLabel} ${donationId}` : `${donationId} ${purposeLabel}`;
		}

		if (orgName && donationId) {
			if (donationName !== orgName) {
				formattedOrgName = isLTR ? `${purposeLabel} ${orgName}` : `${orgName} ${purposeLabel}`;
				formattedDonationId = donationId;
			} else {
				formattedOrgName = '';
				formattedDonationId = isLTR ? `${purposeLabel} ${donationId}` : `${donationId} ${purposeLabel}`;
			}
		}

		return (
			<div className="donate_sub_header donate-main-content">
				<div className="donate-to ppvx_row ppvx_flex-column">
					<div className="ppvx_col-12 title ppvx_flex-column ppvx_justify-content-center">
						<Text
							size="md"
							medium
							className="title-primary no-margins text-center"
						>
							{donateto}
						</Text>
					</div>
				</div>
				
				<div className="ppvx_row">
					<div className="ppvx_col-12">
						<div className="text-center">
							<Text
								as="span"
								size="md"
								medium
								className="title-primary name no-margins"
							>
							  {formattedDonationName}
							</Text>
							
							{getPPCCStatus() === MERCHANT_PPCC_CONFIRMED_STATUS ? <PPCC /> : null}
						</div>
					</div>
				</div>
				
				{
					formattedOrgName &&
					<div className="ppvx_row ppvx_align-items-center ppvx_justify-content-center">
						<Text
							size="md"
							className="ppvx_d-flex no-margins purpose"
						>
							{formattedOrgName}
						</Text>
					</div>
				}
				
				{
					formattedDonationId && this.shouldShowDonationId() &&
					<div className="ppvx_row ppvx_align-items-center ppvx_justify-content-center">
						<Text
							size="md"
							className="ppvx_d-flex no-margins"
						>
						  {formattedDonationId}
						</Text>
					</div>
				}
			</div>
		);
	}
}

SubHeader.propTypes = {
	label: PropTypes.string.isRequired,
	orgName: PropTypes.string.isRequired,
	donationId: PropTypes.string,
	page: PropTypes.string
};

export default SubHeader
